import React from "react";
import { FlexColAlignCenter, YSpacer } from "../styledSystemUtilities";
import styled, { keyframes } from "styled-components";
import theme from "../../theme";
import { Body14 } from "../typography";
import { Color } from "../../types/props/color";

import { FlexRowAlignCenter } from "../styledSystemUtilities";

const spin = keyframes`
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
    
`;

const Spinner = styled.div`
    border: 8px solid hsla(0, 0%, 80%);
    border-radius: 50%;
    border-top: ${(props: { color: Color }) => `8px solid ${theme.colors[props.color]}`};
    width: 100px;
    height: 100px;
    animation: ${spin} 2s linear infinite;
`;

export function LoadingWheel({ color }: { color: Color }): JSX.Element {
    return (
        <FlexColAlignCenter data-testid={"loadingWheel"}>
            <Spinner color={color} />
            <YSpacer spaceY={6} />
            <Body14>Gathering data. This may take a few moments.</Body14>
        </FlexColAlignCenter>
    );
}

export function LoadingWrapper({
    children,
    isLoading,
}: {
    children: React.ReactNode;
    isLoading: boolean;
}): JSX.Element {
    return (
        <>
            {isLoading ? (
                <FlexRowAlignCenter justifyContent={"center"} width={"100%"} pt={"180px"}>
                    <LoadingWheel color={"darkGunmetal"} />
                </FlexRowAlignCenter>
            ) : (
                children
            )}
        </>
    );
}
